import {
  EBadgePosition,
  EBadgeType,
  ESaleDiscountDisplayType,
} from 'utils/enums';
import { Gradient } from 'utils/types';

// TODO remove this interface
interface Emblem {
  imageUrl: string;
}

// TODO remove this interface
interface Ribbon {
  text: string;
  backgroundColor: Gradient;
  textColor: Gradient;
}

// TODO: merge emblem + ribbon under one key
export interface BadgeData {
  type: EBadgeType;
  emblem?: Emblem;
  ribbon?: Ribbon;
  badge?: any;
  salePercentage?: number;
  name?: string;
  className?: string;
  isTextAutoResized?: boolean;
}

export interface IRibbonBadge {
  publisherBadgeId?: string;
  name?: string;
  text: string;
  backgroundColor?: Gradient;
  textColor: Gradient;
  imageUrl?: string;
}

export interface IEmblemBadge {
  publisherBadgeId?: string;
  name?: string;
  imageUrl: string;
}

export interface SaleBadgeProps {
  salePercentage: number;
  salePercentageDisplayType?: ESaleDiscountDisplayType;
  position?: EBadgePosition;
  text?: string;
  designType?: EBadgeDesignType;
  type?: EBadgeType;
  customClassName?: string;
  isTextAutoResized?: boolean;
}

export enum EBadgeDesignType {
  CORNER = 'corner',
  MIDDLE = 'middle',
}
